import { putMobility } from "../api/mobility";
import { useMutation } from "@tanstack/react-query";

const usePutMobility = () => {
  const mutation = useMutation({
    mutationFn: putMobility,
  });
  return mutation;
};

export default usePutMobility;
